import { CtaButton, Grid, Heading } from '@zappyrent/hundop';
import {
  I18nextContext,
  Trans,
  useTranslation,
} from 'gatsby-plugin-react-i18next';
import { upperCase } from 'lodash';
import React from 'react';

import {
  StyledCtaButtonContainer,
  StyledJoinTeamBackground,
  StyledJoinTeamParagraph,
} from './WhoWeAre.styles';

const JoinTheTeam = (): JSX.Element => {
  const { language } = React.useContext(I18nextContext);
  const { t } = useTranslation(['form', 'product']);

  return (
    <>
      <StyledJoinTeamBackground>
        <Grid container alignItems="center" direction="column">
          <Heading
            sm="20px"
            md="32px"
            lg="32px"
            tag="h3"
            charSpacing="-0.64px"
            margin="0px"
            variant="secondary"
          >
            <Trans
              i18nKey="product:joinTeamZappyrent"
              t={t}
              components={{ span: <span /> }}
            />
          </Heading>
          <StyledJoinTeamParagraph>
            <Trans i18nKey="product:joinTeamZappyrent2" t={t} />
          </StyledJoinTeamParagraph>
          <StyledCtaButtonContainer>
            <CtaButton
              href={`${process.env.GATSBY_SITE_URL}/${language}/careers`}
              tag="a"
              title={t('form:openPositions')}
              width="100%"
              user="tenant"
            >
              {upperCase(t('form:openPositions'))}
            </CtaButton>
          </StyledCtaButtonContainer>
        </Grid>
      </StyledJoinTeamBackground>
    </>
  );
};

export default JoinTheTeam;
